module.exports = __webpack_public_path__ + "img/MY.3b160fe7.png";